var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 48,
    viewBox: "0 0 51 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_946_2785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 14V21H12",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 44L23 44L23 36",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 44L29 44L29 36",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 32L47 26L39 26",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 32V26H12",
    stroke: "#6CA5D4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 14L47 21L39 21",
    stroke: "#89B59F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 13,
    r: 3,
    fill: "#DFE9E3",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 13,
    r: 3,
    fill: "#89B59F",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 33,
    r: 3,
    fill: "#6CA5D4",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 33,
    r: 3,
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 44,
    r: 3,
    fill: "#413D45",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 44C18 45.6569 16.6569 47 15 47C13.3431 47 12 45.6569 12 44C12 42.3431 13.3431 41 15 41C16.6569 41 18 42.3431 18 44Z",
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 12H20V6.5C20 3.46243 22.4624 1 25.5 1V1C28.5376 1 31 3.46243 31 6.5V6.5V7",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 25,
    height: 23,
    rx: 4,
    fill: "#C7DFF2",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 23.5002C27.6072 23.0441 28 22.3179 28 21.5C28 20.1193 26.8807 19 25.5 19C24.1193 19 23 20.1193 23 21.5C23 22.3179 23.3928 23.0441 24 23.5002V26.5C24 27.3284 24.6716 28 25.5 28C26.3284 28 27 27.3284 27 26.5V23.5002Z",
    fill: "#413D45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_946_2785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurity);
export default __webpack_public_path__ + "static/media/icon-security.82cbbece929a23c601c294d8956b1dd0.svg";
export { ForwardRef as ReactComponent };